jQuery(document).ready(function($) {
    // Agenda Event Accordion
    $('.agenda-item-trigger').on('click', function() {
        const $trigger = $(this);
        const $content = $trigger.next('.agenda-item-content');
        const $icon = $trigger.find('svg');
        const isExpanded = $trigger.attr('aria-expanded') === 'true';
        
        // Close other items
        $('.agenda-item-trigger').not(this).each(function() {
            $(this).attr('aria-expanded', 'false');
            $(this).attr('data-active', 'false');
            $(this).next('.agenda-item-content').slideUp(300);
            $(this).find('svg').removeClass('rotate-90');
        });

        // Toggle current item
        $trigger.attr('aria-expanded', !isExpanded);
        $trigger.attr('data-active', !isExpanded);
        if (!isExpanded) {
            $content.slideDown(300);
            $icon.addClass('rotate-90');
        } else {
            $content.slideUp(300);
            $icon.removeClass('rotate-90');
        }
    });

    // Default accordion
    $('.accordion-item-trigger').on('click', function() {
        const $trigger = $(this);
        const $content = $trigger.next('.accordion-item-content');
        const $icon = $trigger.find('svg');
        const isExpanded = $trigger.attr('aria-expanded') === 'true';
        
        // Close other items
        $('.accordion-item-trigger').not(this).each(function() {
            $(this).attr('aria-expanded', 'false');
            $(this).attr('data-active', 'false');
            $(this).next('.accordion-item-content').slideUp(300);
            $(this).find('svg').removeClass('rotate-90');
        });

        // Toggle current item
        $trigger.attr('aria-expanded', !isExpanded);
        $trigger.attr('data-active', !isExpanded);
        if (!isExpanded) {
            $content.slideDown(300);
            $icon.addClass('rotate-90');
        } else {
            $content.slideUp(300);
            $icon.removeClass('rotate-90');
        }
    });
});